import { Stack } from '@mui/material';
import React from 'react';
import * as Redux from 'react-redux';
import * as IMG from '../../../helpers/ImagesUtils';
import { getFilesArchivos } from '../../archivos/HelpersArchivos';
import {
  AGE_STYLES_CONST,
  CARRERA_STYLES_CONST,
  DNI_STYLES_CONST,
  LOGO_LEFT_STYLES_CONST,
  LOGO_RIGHT_STYLES_CONST,
  NAMES_STYLES_CONST,
  NIVEL_STYLES_CONST,
  PARAMETRO1_STYLES,
  PARAMETRO2_STYLES,
  PERIODO_STYLES_CONST,
  PHOTO_STYLES_CONST,
  PROFILE_STYLES_CONST,
  SECCION_STYLES_CONST,
  SUBTITLE_STYLES_CONST,
  SURNAMES_STYLES_CONST,
  TITLE_AGE_STYLES_CONST,
  TITLE_CARRERA_STYLES_CONST,
  TITLE_DNI_STYLES_CONST,
  TITLE_FULLNAME_STYLES_CONST,
  TITLE_NIVEL_STYLES_CONST,
  TITLE_PERIODO_STYLES_CONST,
  TITLE_SECCION_STYLES_CONST,
  TITLE_STYLES_CONST,
  componentsCarnet,
} from '../ConstCarnet';
import ImageCarnetComponent from './components_carnet/ImageCarnet';
import TextCarnetComponent from './components_carnet/TextCarnet';

const FrontalCarnet = ({ data, notEdit = false }) => {
  const carnetStore = Redux.useSelector((state) => state.carnet);

  const updatePosition = React.useCallback(
    (idComponent, x, y) => {
      // if (!activo) return;
      if (x && y) {
        if (x < 0) x = 0;
        if (y < 0) y = 0;

        if (x > 100) x = 100;
        if (y > 100) y = 100;

        // dispatch({
        //   type: STYLES_CARNET,
        //   payload: {
        //     ...carnetStore.stylesCarnet,
        //     styles: {
        //       ...carnetStore.stylesCarnet.styles,
        //       x: parseInt(x),
        //       y: parseInt(y),
        //     },
        //   },
        // });

        // setValues({
        //   ...foto,
        //   ejeX: x,
        //   ejeY: y,
        // });

        // clearTimeout(intervalSearch.current);
        // intervalSearch.current = setTimeout(() => {
        //   setActivoCarnetAction(dispatch, values);
        // }, 1000);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return (
    <Stack
      sx={{
        width: '100%',
        height: '100%',
        position: 'relative',
      }}
    >
      <TextCarnetComponent
        name={TITLE_STYLES_CONST}
        notEdit={notEdit}
        carnetStore={carnetStore}
        value={data?.titleText ?? 'Entidad'}
        updatePosition={updatePosition}
      />
      <TextCarnetComponent
        name={SUBTITLE_STYLES_CONST}
        notEdit={notEdit}
        carnetStore={carnetStore}
        value={data?.subtitleText ?? componentsCarnet[1].name}
        updatePosition={updatePosition}
      />
      <TextCarnetComponent
        name={PROFILE_STYLES_CONST}
        notEdit={notEdit}
        carnetStore={carnetStore}
        value={data?.profile}
        updatePosition={updatePosition}
      />
      <ImageCarnetComponent
        name={PHOTO_STYLES_CONST}
        notEdit={notEdit}
        carnetStore={carnetStore}
        value={data?.photo ?? IMG.userm}
        updatePosition={updatePosition}
      />
      <ImageCarnetComponent
        name={LOGO_LEFT_STYLES_CONST}
        notEdit={notEdit}
        carnetStore={carnetStore}
        value={
          carnetStore.activo.logoLeft
            ? getFilesArchivos(carnetStore.activo?.logoLeft)
            : IMG.logoColor
        }
        updatePosition={updatePosition}
      />
      <ImageCarnetComponent
        name={LOGO_RIGHT_STYLES_CONST}
        notEdit={notEdit}
        carnetStore={carnetStore}
        value={
          carnetStore.activo.logoRight
            ? getFilesArchivos(carnetStore.activo?.logoRight)
            : IMG.logoColor
        }
        updatePosition={updatePosition}
      />
      <TextCarnetComponent
        name={TITLE_FULLNAME_STYLES_CONST}
        notEdit={notEdit}
        carnetStore={carnetStore}
        value={data.titleFullnameText ?? 'APELLIDOS Y NOMBRES'}
        updatePosition={updatePosition}
      />
      <TextCarnetComponent
        name={NAMES_STYLES_CONST}
        notEdit={notEdit}
        carnetStore={carnetStore}
        value={data?.names ?? 'NOMBRES DEL USUARIO'}
        updatePosition={updatePosition}
      />
      {data?.surnames && (
        <TextCarnetComponent
          name={SURNAMES_STYLES_CONST}
          notEdit={notEdit}
          carnetStore={carnetStore}
          value={data?.surnames}
          updatePosition={updatePosition}
        />
      )}
      <TextCarnetComponent
        name={TITLE_DNI_STYLES_CONST}
        notEdit={notEdit}
        carnetStore={carnetStore}
        value="NRO. IDENTIFICACIÓN"
        updatePosition={updatePosition}
      />
      {data?.dni && (
        <TextCarnetComponent
          name={DNI_STYLES_CONST}
          notEdit={notEdit}
          carnetStore={carnetStore}
          value={data?.dni ?? 'V-31222444'}
          updatePosition={updatePosition}
        />
      )}
      <TextCarnetComponent
        name={TITLE_NIVEL_STYLES_CONST}
        notEdit={notEdit}
        carnetStore={carnetStore}
        value={data?.titleNivelText ?? 'NIVEL ACADÉMICO'}
        updatePosition={updatePosition}
      />
      <TextCarnetComponent
        name={NIVEL_STYLES_CONST}
        notEdit={notEdit}
        carnetStore={carnetStore}
        value={data?.nivel ?? 'PRIMER AÑO'}
        updatePosition={updatePosition}
      />
      <TextCarnetComponent
        name={TITLE_AGE_STYLES_CONST}
        notEdit={notEdit}
        carnetStore={carnetStore}
        value={data?.titleAgeText ?? 'EDAD'}
        updatePosition={updatePosition}
      />
      <TextCarnetComponent
        name={AGE_STYLES_CONST}
        notEdit={notEdit}
        carnetStore={carnetStore}
        value={
          data?.age
            ? data.age.length > 4
              ? data.age
              : `${data?.age} AÑOS`
            : '14 AÑOS'
        }
        updatePosition={updatePosition}
      />
      <TextCarnetComponent
        name={TITLE_PERIODO_STYLES_CONST}
        notEdit={notEdit}
        carnetStore={carnetStore}
        value="PERÍODO ACADÉMICO"
        updatePosition={updatePosition}
      />
      <TextCarnetComponent
        name={PERIODO_STYLES_CONST}
        notEdit={notEdit}
        carnetStore={carnetStore}
        value={data?.periodo ?? 'PERIODO 2023-2024'}
        updatePosition={updatePosition}
      />
      <TextCarnetComponent
        name={TITLE_SECCION_STYLES_CONST}
        notEdit={notEdit}
        carnetStore={carnetStore}
        value={data?.titleSeccionText ?? 'SECCIÓN'}
        updatePosition={updatePosition}
      />
      <TextCarnetComponent
        name={PARAMETRO1_STYLES}
        notEdit={notEdit}
        carnetStore={carnetStore}
        value={data?.parametro1 ?? 'Parametro 1'}
        updatePosition={updatePosition}
      />
      <TextCarnetComponent
        name={PARAMETRO2_STYLES}
        notEdit={notEdit}
        carnetStore={carnetStore}
        value={data?.parametro2 ?? 'Parametro 2'}
        updatePosition={updatePosition}
      />
      <TextCarnetComponent
        name={SECCION_STYLES_CONST}
        notEdit={notEdit}
        carnetStore={carnetStore}
        value={data?.seccion ?? 'U'}
        updatePosition={updatePosition}
      />
      <TextCarnetComponent
        name={TITLE_CARRERA_STYLES_CONST}
        notEdit={notEdit}
        carnetStore={carnetStore}
        value="CARRERA"
        updatePosition={updatePosition}
      />
      {data?.carrera && (
        <TextCarnetComponent
          name={CARRERA_STYLES_CONST}
          notEdit={notEdit}
          carnetStore={carnetStore}
          value={data?.carrera ?? 'INFORMÁTICA'}
          updatePosition={updatePosition}
        />
      )}
    </Stack>
  );
};

export default FrontalCarnet;
